import gql from 'graphql-tag';

// space pages and space blogs will share the same page card appearance user preference under "globalPageCardAppearancePreference"

export const SpacePagesPersistenceQuery = gql`
	query SpacePagesPersistenceQuery($spaceKey: String!) {
		userPreferences {
			globalPageCardAppearancePreference
			spacePagesSortView(spaceKey: $spaceKey) {
				field
				order
			}
		}
	}
`;
